.toggle.btn-xs {
  min-width: 3rem; min-height: 1.5rem;
}
.toggle-on.btn-xs {
  padding-right: .8rem;
}
.toggle-off.btn-xs {
  padding-left: .8rem;
}

.btn-xs, .btn-group-xs > .btn, .btn-xs-sq {
  padding: 0.05rem 0.4rem;
  font-size: 0.76562rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.toggle input[type="checkbox"] {
	display: block;
	opacity: 0;
	margin-top: 0px !important;
}

.toggle:focus-within {
  border-color: $input-focus-border-color !important;
  outline: 0;
  -webkit-box-shadow: $input-focus-box-shadow;
  box-shadow: $input-focus-box-shadow;
}
